import { parseDateToDDMMYYYY2 } from "./dateTransform";

/**
 * Nombre con el que se identifica una investigacion en toda la app:
 * "#12 - Avanzado 03/09/2026 -Titulo".
 *
 * El titulo es opcional (muchas investigaciones se crean sin el), por eso el
 * id, el tipo y la fecha van siempre: son lo unico que la distingue.
 *
 * Acepta tanto un elemento de investigationList como el snapshot que se guarda
 * dentro de una medida o sancion.
 *
 * @param t Traductor del namespace "information"
 */
export const getInvestigationLabel = (investigation, t) => {
  if (!investigation) return "";

  const { id, advance, created_at: createdAt, title, alias } = investigation;

  // Registros guardados antes de que se denormalizara la investigacion solo
  // traen alias y titulo: no hay con que armar el nombre completo.
  if (id == null && !createdAt) return title || alias || "";

  return `#${id} - ${
    advance ? t("information.advanced") : t("information.basic")
  } ${parseDateToDDMMYYYY2(createdAt)} ${title ? `-${title}` : ""}`;
};
